export const RANKING_COLORS = {
  "": "#000000",
  unrated: "#000000",
  newbie: "#808080",
  pupil: "#008000",
  specialist: "#03a89e",
  expert: "#0000ff",
  "candidate master": "#800080",
  master: "#ffa500",
  "international master": "#ffa500",
  grandmaster: "#ff0000",
  "international grandmaster": "#ff0000",
  "legendary grandmaster": "#ff0000",
};

export const DIVISION_COLORS = {
  DivA: "error",
  DivB: "warning",
  DivC: "primary",
  DivD: "success",
  All: "secondary",
};
